import { Box, BoxProps, useTheme } from '@mui/material'
import { FC, ForwardedRef, forwardRef } from 'react'

interface WaterStatusBoxProps {
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
  status?:  "Good" | "Caution" | "High" | "Low" | "NA"
  boxProps?: BoxProps
}


export const WaterStatusBox= forwardRef<{ },WaterStatusBoxProps>(({ size, status = '', boxProps, ...rest }, ref) => {
  const theme = useTheme()
  const {sx = {}, ...bxprops} = boxProps || {}
  const getBoxSize = () => {
    if (size === 'xlarge') {
      return '64px'
    }
    if (size === 'large') {
      return '48px'
    }
    if (size === 'medium') {
      return '32px'
    }
    if (size === 'small') {
      return '24px'
    }
    if (size === 'xsmall') {
      return '16px'
    }
    return '32px'
  }
  const getBoxColor = () => {
    const boxStatusStr = status.toLowerCase()
    if(boxStatusStr === 'good') { return theme.palette.green[600]}
    if(boxStatusStr === 'caution') { return theme.palette.yellow[600]}
    if(boxStatusStr === 'high' || boxStatusStr === 'low') { return theme.palette.red[600]}
    return theme.palette.grey[0]
  }
  return (
    <Box
      ref={ref}
      borderRadius={1}
      sx={{
        height: getBoxSize(),
        width: getBoxSize(),
        backgroundColor: getBoxColor(),
        boxShadow: 2,
        ...sx
      }}
      {...bxprops}
      {...rest}
    />
  )
}
)